{
  "home": {
    "listen1": "Your Report Card.",
    "listen2": "Digitalization Solution."
  }
}
